(function () {

  function initDescriptionToggle() {
    document.querySelectorAll('.collection-hero__description-container').forEach(container => {

      const text = container.querySelector('.collection-hero__description');
      const btn = container.querySelector('.show-more-btn');

      if (!text || !btn) return;

      // reset
      btn.style.display = 'none';
      text.setAttribute('data-collapsed', 'true');

      // measure full height
      const fullHeight = text.scrollHeight;

      // force collapsed height
      const collapsedHeight = text.clientHeight;

      // show button ONLY if overflow exists
      if (fullHeight > collapsedHeight + 2) {
        btn.style.display = 'inline-block';
      }

      // toggle
      btn.onclick = () => {
        const collapsed = text.getAttribute('data-collapsed') === 'true';

        text.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
        text.style.maxHeight = collapsed ? fullHeight + 'px' : '';
        btn.textContent = collapsed ? 'Show less' : 'Show more';
      };
    });
  }

  window.addEventListener('load', initDescriptionToggle);
  document.addEventListener('shopify:section:load', initDescriptionToggle);

})();